import { HttpClient } from '@angular/common/http';
import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';

import { UserAuthorizationService } from '../../services/user-authorization.service';

@Component({
    templateUrl: './handoff-login.component.html'
})
export class HandoffLoginComponent implements OnInit {

    error?: string;

    private route = inject(ActivatedRoute);
    private router = inject(Router);
    private userAuthorizationService = inject(UserAuthorizationService);

    async ngOnInit() {
        const code = this.route.snapshot.queryParamMap.get('code');

        if (!code) {
            // no code → go to login or home
            await this.navigateToLogin();
            return;
        }

        try {
            var currentUser = await this.userAuthorizationService.getOrLoadUser();
            if (currentUser != null) {
                await this.navigateToLogin();
                return;
            }

            await firstValueFrom(this.userAuthorizationService.loginWithHandoffCode(code));
            // Drop ?code= from the address bar
            window.history.replaceState({}, '', this.router.createUrlTree(['/login/handoff']).toString());
            await this.userAuthorizationService.loadUserAsync();
            await this.navigateToLogin();
        } catch (e) {
            await this.navigateToLogin();
        }
    }

    async navigateToLogin() {
        await this.router.navigateByUrl('/home');
    }

}
